import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {Planning} from '../../../../_interfaces/planning/planning';
import {Router} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'app-modal-planning-view',
	templateUrl: './modal-planning-view.component.html',
	styleUrls: ['./modal-planning-view.component.scss'],
})

export class ModalPlanningViewComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public planning: Planning,
		private router: Router,
		public dialogRef: MatDialogRef<ModalPlanningViewComponent>
	) {
	}

	redirect(client_id: number): void {
		this.dialogRef.close();
		this.router.navigate(['/clients/' + client_id + '/view']).then((): void => {});
	}

}
